import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PriceAnchor() {
  const includedBullets = ['Immediate Digital Delivery', 'Read On Any Device', 'Bonus Resources Included', 'Secure Checkout', '60-Day Satisfaction Guarantee'];
  return <section className="py-20 bg-white" data-id="element-183">
      <div className="max-w-2xl mx-auto px-6" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-sky-100 overflow-hidden" data-id="element-185">
          {/* Header banner */}
          <div className="bg-sky-500 text-white text-center py-3 px-6" data-id="element-186">
            <span className="text-xs font-bold uppercase tracking-widest" data-id="element-187">
              Special Introductory Offer
            </span>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-188">
            <h2 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-6" data-id="element-189">
              Today You Can Get Instant Access For Only
            </h2>

            {/* Value breakdown */}
            <div className="bg-slate-50 rounded-2xl p-5 mb-6 text-left text-sm space-y-2" data-id="element-190">
              <div className="flex justify-between text-slate-600" data-id="element-191">
                <span data-id="element-192">The Dental Sugar Hack eBook</span>
                <span className="font-semibold" data-id="element-193">$47</span>
              </div>
              <div className="flex justify-between text-slate-600" data-id="element-194">
                <span data-id="element-195">Bonus #1: 24h Bad Breath Fix</span>
                <span className="font-semibold" data-id="element-196">$17</span>
              </div>
              <div className="flex justify-between text-slate-600" data-id="element-197">
                <span data-id="element-198">Bonus #2: Hollywood White Protocol</span>
                <span className="font-semibold" data-id="element-199">$17</span>
              </div>
              <div className="flex justify-between text-slate-600" data-id="element-200">
                <span data-id="element-201">Bonus #3: Sweet Tooth Secret</span>
                <span className="font-semibold" data-id="element-202">$16</span>
              </div>
              <div className="border-t border-slate-200 pt-2 mt-2 flex justify-between text-slate-700 font-bold" data-id="element-203">
                <span data-id="element-204">Total Value</span>
                <span className="line-through text-slate-400" data-id="element-205">$97</span>
              </div>
            </div>

            <div className="mb-2 text-slate-500 text-sm font-medium uppercase tracking-wider" data-id="element-206">
              Today's Price
            </div>
            <div className="flex items-baseline justify-center text-orange-500 mb-8" data-id="element-207">
              <span className="text-3xl font-bold mr-1" data-id="element-208">$</span>
              <span className="text-7xl font-playfair font-bold leading-none" data-id="element-209">
                17
              </span>
            </div>

            {/* Included list */}
            <ul className="text-left space-y-2 mb-8 max-w-sm mx-auto" data-id="element-210">
              {includedBullets.map((item, i) => <li key={i} className="flex items-center text-sm text-slate-700" data-id="element-211">
                  <div className="w-5 h-5 rounded-full bg-sky-500 flex items-center justify-center mr-3 shrink-0" data-id="element-212">
                    <CheckIcon size={12} className="text-white" strokeWidth={3} data-id="element-213" />
                  </div>
                  {item}
                </li>)}
            </ul>

            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-12 rounded-full transition-all transform hover:scale-105 shadow-lg text-lg" data-id="element-214">
              Yes! I Want Instant Access
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}